/**
 * ExportPanel - Insole export format selection and download
 */

import React, { useState } from 'react'
import type { ExportFormat } from '../../../services/types'
import './ExportPanel.css'

interface ExportPanelProps {
  /** Callback to export in chosen format */
  onExport: (format: ExportFormat) => void
  /** Loading state */
  isLoading?: boolean
  /** Last export result */
  exportResult?: { export_id: string; file_size_bytes: number; format: string } | null
}

export const ExportPanel: React.FC<ExportPanelProps> = ({
  onExport,
  isLoading = false,
  exportResult
}) => {
  const [format, setFormat] = useState<ExportFormat>('stl')

  return (
    <div className="export-panel">
      <h4>Export</h4>
      <div className="export-format-row">
        {(['stl', '3mf', 'obj'] as ExportFormat[]).map(f => (
          <button
            key={f}
            className={`export-format-btn ${format === f ? 'selected' : ''}`}
            onClick={() => setFormat(f)}
            disabled={isLoading}
          >
            {f.toUpperCase()}
          </button>
        ))}
      </div>
      <button
        onClick={() => onExport(format)}
        disabled={isLoading}
        className="export-download-btn"
      >
        {isLoading ? 'Exporting...' : `Export as ${format.toUpperCase()}`}
      </button>
      {exportResult && (
        <div className="export-result">
          Export ready: {(exportResult.file_size_bytes / 1024).toFixed(1)} KB ({exportResult.format})
        </div>
      )}
    </div>
  )
}
